export default __webpack_public_path__ + "static/promotions-step-3-ff4395104a824ff1835e416680b650e5.svg";